import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Card from '../content/Card';
import { Header } from 'formlabs-web-components/Type';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import './webinars.module.css';
import { withTranslation } from 'react-i18next';

const WebinarList = DisplayComponent(
  class WebinarList extends PureComponent {
    render() {
      const {
        classes,
        styleNames,
        styles,
        webinars,
        t,
        page,
        hasNext,
        hasPrev
      } = this.props;

      const prev = parseInt(page, 10) - 1;
      const next = parseInt(page, 10) + 1;

      const listItems = webinars.map(webinar => (
        <Cell
          key={`${webinar.link} ${webinar.title}`}
          largeSize={8}
          mediumSize={12}
        >
          <Card
            bgColor="transparent-black"
            padding="20px"
            internalPadding="none"
            videoOverlay={true}
            url={webinar.webinarURL}
            image={webinar.image}
            imageAlt={webinar.title}
            imageConstraint="100%"
            imagePosition="top"
            eyebrowText={webinar.category}
            bottomRightLabelText={webinar.runtime}
            titleStyle="thin"
            title={webinar.title}
            caption={webinar.date}
          >
            <p styleName="watch-now">{t('Watch Now')} ></p>
          </Card>
        </Cell>
      ));

      return (
        <div
          className={classes}
          styleName={classNames(styleNames)}
          style={styles}
        >
          <Grid direction="x" gutters="margin">
            {listItems}
          </Grid>
          <div styleName="pagination-wrapper">
            {hasPrev && (
              <Button
                color="light"
                rel="prev"
                url={prev > 0 ? `?page=${prev}` : null}
              >
                <i className="fl-arrow-left" /> {t('Previous')}
              </Button>
            )}
            {hasNext && (
              <Button
                styleName="pagination-button"
                color="light"
                rel="next"
                url={`?page=${next}`}
              >
                {t('Next')} <i className="fl-arrow-right" />
              </Button>
            )}
          </div>
        </div>
      );
    }
  }
);

export default withTranslation()(WebinarList);
